<template>
  <div>
    <b-modal ref="viewFormModal" id="viewFormModal" size="lg" hide-footer v-bind:title="title">
      <table style="width: 100%;">
        <tr v-for="key in printableKeys" :key="key">
          <td><strong>{{ key | capitalize }} </strong></td>
          <td style="padding-left: .25em;">{{ scenario[key] }}</td>
        </tr>
      </table>
      <strong>graph</strong><br/>
      <pre> {{ graph }}</pre>
    </b-modal>
    <b-modal size="lg" ref="addFormModal" id="addFormModal" hide-footer v-bind:title="title">
      <form v-on:submit.prevent="onAddEdit">
        <div class="card">
          <div class="card-header">
            Attributes
          </div>
          <div class="card-body">
            <InputText v-if="edit" prefix="Scenario" name="identifier" v-model="identifier" disabled
                       required></InputText>

            <div class="form-group row">
              <label class="col-sm-3 col-form-label" for="Bundle">Bundle </label>
              <div class="col-sm-9">
                <TypeAhead prefix="Scenario" id="Bundle" resourceType="bundle" required v-model="bundle" class="mb-2"
                           @hit="bundleIdentifier=$event" :disabled="edit"/>
              </div>
            </div>

            <InputText prefix="Scenario" name="alias" v-model="alias" required
                       pattern="[a-zA-Z0-9\-_]{3,50}"></InputText>
            <InputText prefix="Scenario" name="qualifier" v-model="qualifier" required></InputText>

            <div class="form-group row">
              <label class="col-sm-3 col-form-label" for="Category">Category</label>
              <div class="col-sm-9">
                <TypeAhead prefix="Scenario" resourceType="category" v-model="category" class="mb-2" id="Category"
                           @hit="categoryIdentifier=$event"
                           :filters="{bundleIdentifier: bundleIdentifier}" :disabled="bundleIdentifier === null"/>
              </div>
            </div>
            <InputText prefix="Scenario" name="name" v-model="name"></InputText>
            <TextAreaForm ref="graph" prefix="Scenario" name="graph" v-model="graph" required :rows="10"
                          :json="true"></TextAreaForm>
            <TextAreaForm ref="description" prefix="Scenario" name="description" v-model="description"></TextAreaForm>
            <TextAreaForm ref="attributes" prefix="Scenario" name="attributes" v-model="attributes" :rows="5"
                          :json="true"></TextAreaForm>
            <button type="submit" class="btn btn-primary">Submit</button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import store from '../../store'
import TypeAhead from '../form/TypeAhead'
import InputText from '../form/InputText'
import TextAreaForm from '../form/TextAreaForm'
import {Tag} from '@/common'
import {print_tag} from '@/filters'

export default {
  name: 'ScenarioListForm',
  created() {

    this.$eventBus.$off("view-scenario-show")
    this.$eventBus.$on("view-scenario-show", (identifier) => {
      this.reset("Scenario")
      let scenario = store.getters['scenarios/get'](identifier)
      this.scenario = scenario
      if (scenario.graph) {
        this.graph = JSON.stringify(scenario.graph, null, 4)
      }
      this.printableKeys = ["tag", "identifier", "bundle", "name", "category", "description", "attributes"]
      this.$refs.viewFormModal.show()
    })

    this.$eventBus.$off("add-scenario-show")
    this.$eventBus.$on("add-scenario-show", (bundleIdentifier) => {
      this.reset("Add scenario")
      if (this.$refs.graph) this.$refs.graph.$emit('reset')
      if (this.$refs.attributes) this.$refs.attributes.$emit('reset')
      if (this.$refs.description) this.$refs.description.$emit('reset')
      if (bundleIdentifier !== undefined) {
        this.bundleIdentifier = bundleIdentifier
        this.bundle = store.getters['bundles/get'](bundleIdentifier).tag
      }
      this.$refs.addFormModal.show()
    })

    this.$eventBus.$off("edit-scenario-show")
    this.$eventBus.$on("edit-scenario-show", (identifier) => {
      store.dispatch('scenarios/load', identifier).then((values) => {
        this.reset("Edit scenario")
        let scenario = store.getters['scenarios/get'](identifier)
        this.identifier = scenario.identifier
        this.alias = scenario.alias
        this.qualifier = scenario.qualifier
        this.tag = scenario.tag
        this.name = scenario.name
        this.graph = scenario.graph
        this.description = scenario.description
        this.attributes = scenario.attributes
        this.categoryIdentifier = scenario.category_identifier
        this.edit = true
        this.bundleIdentifier = scenario.bundle_identifier
        if (this.$refs.graph) this.$refs.graph.$emit('reset', this.graph)
        if (this.$refs.attributes) this.$refs.attributes.$emit('reset', this.attributes)
        if (this.$refs.description) this.$refs.description.$emit('reset', this.description)

        let bundleIdentifier = this.bundleIdentifier
        let categoryIdentifier = this.categoryIdentifier
        let promises = [store.dispatch('bundles/load', bundleIdentifier)]
        if (categoryIdentifier != null) {
          promises.push(store.dispatch('categories/load', categoryIdentifier))
        }
        Promise.all(promises).then((values) => {
          this.bundle = store.getters['bundles/get'](bundleIdentifier).tag
          let category = store.getters['categories/get'](categoryIdentifier)
          this.category = category != null ? category.name : null
          this.$refs.addFormModal.show()
        })
      })
    })

    this.$eventBus.$off("delete-scenario-show")
    this.$eventBus.$on("delete-scenario-show", (identifier) => {
      let scenario = store.getters['scenarios/get'](identifier)
      this.$deleteModal({
        text: "Do you really want to delete scenario " + print_tag(null, null, scenario)
      }).then((result) => {
        if (result.value) {
          store.dispatch('scenarios/delete', scenario.identifier).then(() => {
            this.$eventBus.$emit('success', 'The scenario has been deleted')
          }).catch((response) => {
            this.$eventBus.$emit('http-error', response)
          })
        }
      })
    })

    this.$eventBus.$off('export-scenario')
    this.$eventBus.$on('export-scenario', (identifier) => {
      let scenario = store.getters['scenarios/get'](identifier)
      store.dispatch('bundles/export', {
        bundle_identifier: scenario.bundle_identifier,
        resources: [scenario.identifier]
      }).then(() => {
        this.$eventBus.$emit('success', 'The scenario has been exported')
      }).catch((response) => {
        this.$eventBus.$emit('http-error', response)
      })
    })

  },
  data() {
    return {
      identifier: null,
      scenario: null,
      printableKeys: {},
      alias: null,
      qualifier: null,
      tag: null,
      name: null,
      description: null,
      category: null,
      categoryIdentifier: null,
      graph: {},
      attributes: {},
      title: "",
      edit: false,
      bundle: null,
      bundleIdentifier: null
    }
  },
  computed: {
    scenarios: () => store.getters['scenarios/getAll']()
  },
  methods: {
    reset(title) {
      this.title = title
      this.edit = false
      this.identifier = null
      this.alias = null
      this.qualifier = null
      this.tag = null
      this.name = null
      this.description = null
      this.categoryIdentifier = null
      this.graph = {}
      this.attributes = {}
      this.bundle = null
      this.bundleIdentifier = null
    },
    onAddEdit() {
      let data = {
        "tag": new Tag(this.alias, this.qualifier).print(),
        "name": this.name,
        "command": this.command,
        "description": this.description,
        "category_identifier": this.categoryIdentifier,
        "graph": this.graph,
        "attributes": this.attributes
      }

      if (this.edit) {
        store.dispatch('scenarios/update', {
          bundleIdentifier: this.bundleIdentifier,
          identifier: this.identifier, data: data
        }).then(() => {
          this.$refs.addFormModal.hide()
          this.$eventBus.$emit('success', 'The scenario has been updated')
        }).catch((response) => {
          this.$eventBus.$emit('http-error', response)
        })
      } else {
        store.dispatch('scenarios/add', {bundleIdentifier: this.bundleIdentifier, data: data}).then(() => {
          this.$refs.addFormModal.hide()
          this.$eventBus.$emit('success', 'The scenario has been created')
        }).catch((response) => {
          this.$eventBus.$emit('http-error', response)
        })
      }
    },
  },
  components: {
    InputText, TextAreaForm, TypeAhead
  }
}
</script>

<style>

</style>
